import { defineComponent, PropType, computed } from 'vue'
import { ChannelType } from '../../cmsElements/M/M_ChannelTeaser/M_ChannelTeaser.interface'
import { MsClickArea } from '@sunrise/components'
import {
    MsImmo as ImmoIcon,
    MsJobs as JobsIcon,
    MsAuto as AutoIcon,
    MsLocalInformation as LocalInformationIcon,
} from '@sunrise/icons'

import ImmoBackground from './immo.svg?component'
import JobsBackground from './jobs.svg?component'
import AutoBackground from './auto.svg?component'
import LocalInformationBackground from './local-information.svg?component'
import { createTealiumTracking, MsTracking } from '@sunrise/tracking'

export default defineComponent({
    name: 'CsChannelTeaser',
    components: {
        MsClickArea,
        ImmoIcon,
        ImmoBackground,
        JobsIcon,
        JobsBackground,
        AutoIcon,
        AutoBackground,
        LocalInformationIcon,
        LocalInformationBackground,
    },
    props: {
        channel: {
            type: String as PropType<ChannelType>,
            required: true,
        },
        href: {
            type: String,
            required: true,
        },
        rel: {
            type: String,
        },
        target: {
            type: String,
        },
    },
    setup(props) {
        return { computedProps: computed(() => vmPropsMap[props.channel]()) }
    },
})

type VmProps = {
    headlineText: string
    backgroundClass: string
    backgroundComponentName: string
    iconComponentName: string
    trackingData: MsTracking[]
}

const createTracking = (typeText: string) => [
    createTealiumTracking({
        mslayer_element_data_id: 'ed0000217',
        mslayer_element_text: 'Kacheleinstieg_Startseite',
        mslayer_element_type_text: typeText,
        mslayer_element_count: 'not_set',
        mslayer_element_variant: 'native',
        mslayer_element_body_type: 'text_body',
        mslayer_element_position: 'not_set',
        mslayer_element_id: 'not_set',
        mslayer_affiliate_id: 'not_set',
        mslayer_element_company_name: 'not_set',
        mslayer_element_detail_start_date: 'not_set',
    }),
]

const vmPropsMap: Record<ChannelType, () => VmProps> = {
    [ChannelType.Immo]: () => ({
        headlineText: `Immobilien`,
        backgroundClass: `bg-color-signatur-immo-100`,
        backgroundComponentName: `ImmoBackground`,
        iconComponentName: `ImmoIcon`,
        trackingData: createTracking(`Immobilien`),
    }),
    [ChannelType.Jobs]: () => ({
        headlineText: `Jobs`,
        backgroundClass: `bg-color-signatur-jobs-100`,
        backgroundComponentName: `JobsBackground`,
        iconComponentName: `JobsIcon`,
        trackingData: createTracking(`Jobs`),
    }),
    [ChannelType.Auto]: () => ({
        headlineText: `Auto`,
        backgroundClass: `bg-color-signatur-auto-100`,
        backgroundComponentName: `AutoBackground`,
        iconComponentName: `AutoIcon`,
        trackingData: createTracking(`Auto`),
    }),
    [ChannelType.LocalInformation]: () => ({
        headlineText: `Lokales`,
        backgroundClass: `bg-color-brand-yellow-50`,
        backgroundComponentName: `LocalInformationBackground`,
        iconComponentName: `LocalInformationIcon`,
        trackingData: createTracking(`Aktuell`),
    }),
}
